import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ConfirmDialogService, ConfirmDialogState } from '../../../core/services/confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  state!: ConfirmDialogState;
  private sub!: Subscription;

  constructor(private svc: ConfirmDialogService) {}

  ngOnInit() {
    this.sub = this.svc.state$.subscribe(s => this.state = s);
  }

  ngOnDestroy() { this.sub.unsubscribe(); }

  confirm() { this.svc.respond(true); }
  cancel()  { this.svc.respond(false); }
}
